import { Box, Grid, Typography } from "@material-ui/core";
import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import AccountCreditLayout from "./AccountCreditLayout";
import { useTranslation } from "react-i18next";
import { getDisplayAmount } from "./ManageSubscriptionForm";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    proratedBox: {
      marginTop: "30px",
      marginBottom: "40px",
      width: "80%",
    },
    productText: {
      color: theme.palette.dark.main,
      fontWeight: "bold",
      justifyContent: "left",
      display: "flex",
    },
    totalText: {
      color: theme.palette.dark.main,
      fontWeight: "bold",
      justifyContent: "right",
      display: "flex",
    },
  })
);

export default function SubscriptionTotalData(props: IProps) {
  const classes = useStyles();
  const { t } = useTranslation();
  const { amountDue, country } = props;

  return (
    <React.Fragment>
      <Box className={classes.proratedBox}>
        <Grid container>
          <Grid item xs={8}>
            <Typography className={classes.productText}>
              {t("total_amount_due_today")}
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography className={classes.totalText}>
              {getDisplayAmount(amountDue > 0 ? amountDue / 100 : 0, country)}
            </Typography>
          </Grid>
        </Grid>

        {amountDue < 0 && (
          <AccountCreditLayout
            amountDue={amountDue * -1}
            country={country}
          ></AccountCreditLayout>
        )}
      </Box>
    </React.Fragment>
  );
}

interface IProps {
  amountDue: number;
  country: string;
}
